module.exports = __webpack_public_path__ + "static/media/Mapoon.30c18a9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_logos/Mapoon.png
// module id = 639
// module chunks = 0